import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpErrorInterceptorService } from '@app/shared/errors/http-error-interceptor.service';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';
import { CompanyLogoMetadata } from './company.model';

@Injectable({
  providedIn: 'root',
})
export class CompanyLogoService {
  private http = inject(HttpClient);
  private httpErrorInterceptorService = inject(HttpErrorInterceptorService);
  private url = `${inject(RUNTIME_CONFIG).apiUrl}/companies`;

  constructor() {
    this.httpErrorInterceptorService.addIgnoreHttpStatusForUrlBeginningBy(
      404,
      'GET',
      `${this.url}/`,
    );
  }

  findById(id: string): Observable<CompanyLogoMetadata> {
    return this.http.get<CompanyLogoMetadata>(`${this.url}/${id}/logo`);
  }

  getLogoSrcUrl(companyId: string): string {
    return `${this.url}/${companyId}/logo/blob`;
  }
}
